import React from "react";

import { makeStyles, DownloadIcon } from "../../shared/materials/helper";
import ChallanPopperButton from "../../shared/materials/Buttons/ChallanPopperButton";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: theme.spacing(3),
  },
  header: {
    margin: 0,
    color: "rgba(54, 43, 115, 1)",
    fontSize: 32,
    fontWeight: 700,
  },
  buttonText: {
    fontWeight: 700,
  },
  buttonContent: {
    display: "flex",
    alignItems: "center",
  },
}));

const TransactionHeader = ({ downloadReport }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Transactions</h1>
      <ChallanPopperButton
        borderColor={"rgba(226, 19, 110, 1)"}
        bg={"rgba(226, 19, 110, 0.04)"}
        color={"rgba(226, 19, 110, 1)"}
        onClick={downloadReport}
        width={220}
      >
        <div className={classes.buttonContent}>
          <DownloadIcon sx={{ mr: 1, mt: 0.25 }} />
          <span>Download Daily CSV</span>
        </div>
      </ChallanPopperButton>
    </div>
  );
};

export default TransactionHeader;
